// Unregister-only, on purpose.
//
// This app has never shipped a service worker: react-scripts 4 only emits
// build/service-worker.js when src/service-worker.ts exists, and it never has
// here — so the register() call that used to live in index.tsx asked for a
// file that 404'd on every production load and could not ever succeed.
//
// The CRA scaffolding that used to fill this file (register /
// registerValidSW / checkValidServiceWorker and a header explaining how to
// "opt in") advertised an opt-in that cannot work in this repo, and following
// it would only reinstate the 404. If offline support is ever actually
// wanted, start from CRA4's src/service-worker.ts workbox template — do not
// resurrect register() here.
//
// unregister() stays called (see index.tsx): besides ending the failed
// registration attempts, it evicts any worker an older deployment on this
// origin may have left behind — such a worker serves its own cache forever
// and no deploy can dislodge it.

export function unregister() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.ready
			.then(registration => {
				registration.unregister()
			})
			.catch(error => {
				console.error(error.message)
			})
	}
}
